import React, { useState, useEffect } from "react";
import * as XLSX from 'xlsx'
import styled from "@emotion/styled";
import {
  Button,
  FormControl,
  MenuItem,
  Select,
  Grid,
  CircularProgress,
  Box,
  TextField,
  IconButton,
} from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import editButton from "../../../assets/editView.svg";
import Layout from "components/structure/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import Service from "../../../services/CropStageCalander";
import CropStageCalendarService from "../../../services/CropStageCalander";
import { SnackbarContext } from "context/snackBarContext";
import { AuthData } from "auth/AuthWarpper";
import EditButton from "utils/EditButton";
import { formatDate } from "utils/utils";
import DataTable from "utils/DataTable/DataTable";
import "./CropStageCalendar.css";
import SeasonRegistrationService from "services/SeasonRegistrationService";
import NoData from "assets/noData.svg";
import CommonService from "services/CommonService";
import QuestionnareService from "services/QuestionnareService";
import Eye from "assets/Eye.svg";
import PaginationImport from "../Import/Common/PaginationImport";
import CustomPagination from "../Import/Common/CustomPagination";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";


const RegistrationOptions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Heading = styled.div`
  color: rgba(115, 125, 134, 1);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;
const DataContainer = styled.div``;

const CropStageCalendar = () => {
  dayjs.extend(utc);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20); // Number of items per page
  const [totalItems, setTotalItems] = useState(7); // Num
  const location = useLocation();
  const { state } = location;
  const [tableVisible, setTableVisible] = useState(false);
  const [cropYear, setCropYear] = useState(
    state?.cropYear ? state.cropYear : "default"
  );
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = React.useState(false);
  // const [totalRowCount, setTotalRowCount] = useState(0);
  // const [paginationModel, setPaginationModel] = useState({
  //   page: 0,
  //   pageSize: 10,
  // });
  const [cropYears, setCropYears] = useState([]);
  const [countries, setCountries] = useState([]);
  const [firstCountry, setFirstCountry] = useState(null);
  const [questions, setQuestions] = useState(null);
  const [selectCountry, setSelectCountry] = useState(
    countries[0]?.countryCode || ""
  );
  const [selectQuestion, setSelectQuestion] = useState(
    state?.selectQuestion ? state.selectQuestion : "default"
  );

  const [isYearClicked, setIsYearClicked] = useState(false);

  // const { user } = AuthData();
  const user = JSON.parse(sessionStorage.getItem('BAT_USER'))


  const navigate = useNavigate();
  const {
    severity,
    message,
    openAlert,
    setOpenAlert,
    setSeverity,
    setMessage,
  } = React.useContext(SnackbarContext);
  const columns = [
    {
      field: "countryName",
      headerName: "Country",
      // width: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "cropYear",
      headerName: "Crop Year",
      // width: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "seasonCode",
      headerName: "Season Code",
      // width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "seasonName",
      headerName: "Season Name",
      // width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "cropStageName",
      headerName: "Crop Stage",
      // width: 400,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "StartFormatDate",
      headerName: "Start Date",
      // width: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "EndFormatDate",
      headerName: "End Date",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "activeInd",
      headerName: "Status",
      renderCell: (params) => (
        <span>
          {" "}
          {JSON.stringify(params?.row?.activeInd) == "true"
            ? "Active"
            : "Inactive"}
        </span>
      ),
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      headerAlign: "center",
      flex: 1,
      align: "center",
      getActions: (params) => [
        <EditButton
          state={{ row: params.row, isYearClicked: isYearClicked}}
          url={"/editCropStageCalendar"}
          disabled={read_only_user}
        />,
      ],
    },
  ];

  const columnsGlobal = [
    {
      field: "countryName",
      headerName: "Country",
      // width: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "cropYear",
      headerName: "Crop Year",
      // width: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "seasonCode",
      headerName: "Season Code",
      // width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "seasonName",
      headerName: "Season Name",
      // width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "cropStageName",
      headerName: "Crop Stage",
      // width: 400,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "StartFormatDate",
      headerName: "Start Date",
      // width: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "EndFormatDate",
      headerName: "End Date",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "activeInd",
      headerName: "Status",
      renderCell: (params) => (
        <span>
          {" "}
          {JSON.stringify(params?.row?.activeInd) == "true"
            ? "Active"
            : "Inactive"}
        </span>
      ),
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      headerAlign: "center",
      flex: 1,
      align: "center",
      renderCell: (params) => (
        <img
          onClick={() =>
            navigate("/editCropStageCalendar", {
              state: { row: params.row, view: true },
            })
          }
          src={Eye}
          alt="Eye"
          style={{ cursor: "pointer" }}
        />
      ),
    },
  ];

  const moduleName = "Manage Operations";
  const functionalityName = "Crop Stage Calendar";

  const read_only_user = user?.accessibleModules
    ?.find(module => module.module_name === moduleName)
    ?.accessible_functionalities
    ?.find(func => func.functionality_name === functionalityName)
    ?.read_only;

  useEffect(() => {
    if (cropYear) fetchCropStageCalendar(currentPage, itemsPerPage);
  }, []);

  useEffect(() => {
    let apiCountryCode = user?.userAttribute == "Local" ? user?.countryCode : `${selectCountry ? selectCountry : firstCountry?.countryCode}`
    const headers = {
      apiCountryCode: apiCountryCode, // Replace 'your_tenant_id' with the actual tenant ID
    };
    CropStageCalendarService.getCropYears({ headers })
      .then((response) => {
        const cropYearsFromApi = response.data.response.map(
          (item) => item.cropYear
        );
        setCropYears(cropYearsFromApi); // Store crop years in state
      })
      .catch((error) => {
        setCropYears([])
        console.error("Error fetching data:", error)
      });
  }, [selectCountry]);

  useEffect(() => {
    CommonService.fetchCountries()
      .then((response) => {
        const data = response.data.response;
        setCountries(data);
        if (data.length > 0) {
          setFirstCountry(data[0]);
          setSelectCountry(data[0]?.countryCode);
          // Set the first country in a separate state
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    QuestionnareService.FetchDropdown()
      .then((response) => {
        const data = response.data?.response?.cropStageResponse;
        setQuestions(data);
        // setCountries(data);
      })
      .catch((error) => console.error("Error fetching data:", error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const paginate = (pageNumber, itemsPerPage) => {
    fetchCropStageCalendarAll(cropYears, pageNumber - 1, itemsPerPage)
  }

  const fetchCropStageCalendar = (pNumber, size) => {
    if (cropYear == "default") return;
    setLoading(true);
    setRows([]);
    const query = `cropYears=${cropYear}&countryCode=${user?.countryCode ? user?.countryCode : ""
      }`;
    CropStageCalendarService.getCropStageCalendarList(pNumber, size, query)
      .then((res) => {
        setLoading(false);
        let data = res?.data?.response.cropStageCalendars;
        let total = res?.data?.response?.totalItems;
        data?.forEach((ele, index) => {
          ele.id = index;
          ele.StartFormatDate = dayjs.utc(ele?.startDate)?.format("DD/MM/YYYY");
          ele.EndFormatDate = dayjs.utc(ele?.endDate)?.format("DD/MM/YYYY")
        });
        setRows(data);
        // setTotalRowCount(total)
        setCurrentPage(pNumber);
        setItemsPerPage(size)
        setTotalItems(total)
      })
      .catch((error) => {
        setLoading(false);

        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
        setSeverity("error");
      });
  };

  useEffect(() => {
    if (firstCountry?.countryCode && cropYears.length > 0 && !state?.cropYear) {
      fetchCropStageCalendarAll(cropYears, currentPage, itemsPerPage); // Call only when both data are available
    }
  }, [firstCountry, cropYears]); // Dependencies are firstCountry and cropYears

  // const fetchCropStageCalendarAll = (allCropYear) => {
  //   console.log("all", allCropYear);
  //   // if (cropYear == "default") return
  //   setLoading(true);
  //   setRows([]);
  //   const cropYearList = allCropYear
  //     .map((year) => `cropYears=${year}`)
  //     .join("&");
  //   console.log("cropYearList", cropYearList);
  //   const query = `${cropYearList}`;
  //   CropStageCalendarService.getCropStageCalendarListAll(query)
  //     .then((res) => {
  //       setLoading(false);
  //       let data = res?.data?.response;
  //       let total = res?.data?.response?.totalItems;
  //       data?.forEach((ele, index) => {
  //         ele.id = index;
  //         ele.StartFormatDate = formatDate(ele?.startDate);
  //         ele.EndFormatDate = dayjs.utc(ele?.endDate).format("DD/MM/YYYY"),
  //       });
  //       setRows(data);
  //       // setTotalRowCount(total)
  //     })
  //     .catch((error) => {
  //       setLoading(false);

  //       setMessage(error?.response?.data?.message || error?.message);
  //       setOpenAlert(true);
  //       setSeverity("error");
  //     });
  // };

  const fetchCropStageCalendarAll = (allCropYear, pNumber, size) => {
    setLoading(true);
    setRows([]);

    let queryParams = [];
    const cropYearList = allCropYear
      .map((year) => `cropYears=${year}`)
      .join("&");

    // Only add cropYear if it's not a default value (e.g., undefined, null, or empty string)
    if (cropYear !== "default") {
      queryParams.push(`cropYears=${cropYear}`);
    } else {
      queryParams.push(`${cropYearList}`);
    }

    // Only add selectQuestion if it's not a default value (e.g., undefined, null, or empty string)
    if (selectQuestion !== "default") {
      queryParams.push(`cropStageId=${selectQuestion}`);
    }

    // Join the query parameters with '&' to form the final query string
    const query = queryParams.length ? queryParams.join("&") : "";

    // Define headers, including x-tenantid
    // const headers = {
    //   apiCountryCode: `${selectCountry}`, // Replace 'your_tenant_id' with the actual tenant ID
    // };



    // const query = `${cropYearList}`;

    // Define headers, including x-tenantid
    const headers = {
      apiCountryCode: `${selectCountry ? selectCountry : firstCountry.countryCode}`, // Replace 'your_tenant_id' with the actual tenant ID
    };
    if (selectQuestion !== "default") {
      queryParams.push(`cropStageId=${selectQuestion}`);
    }
    // Pass headers as an option to the service call
    CropStageCalendarService.getCropStageCalendarListAll(pNumber, size, query, { headers })
      .then((res) => {
        setLoading(false);
        let data = res?.data?.response.cropStageCalendars;
        let total = res?.data?.response?.totalItems;

        data?.forEach((ele, index) => {
          ele.id = index;
          ele.StartFormatDate = dayjs.utc(ele?.startDate).format("DD/MM/YYYY");
          ele.EndFormatDate = dayjs.utc(ele?.endDate).format("DD/MM/YYYY")
        });

        setRows(data);
        setCurrentPage(pNumber);
        setItemsPerPage(size)
        setTotalItems(total)
        // setTotalRowCount(total);
      })
      .catch((error) => {
        setLoading(false);
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
        setSeverity("error");
      });
  };

  const multiFilter = (pNumber, size) => {
    setLoading(true);
    setRows([]);

    // Initialize an empty array for query parameters
    let queryParams = [];

    // Only add cropYear if it's not a default value (e.g., undefined, null, or empty string)
    if (cropYear !== "default") {
      queryParams.push(`cropYears=${cropYear}`);
    } else {
      cropYears?.forEach(element => {
        queryParams.push(`cropYears=${element}`);
      });

    }

    // Only add selectQuestion if it's not a default value (e.g., undefined, null, or empty string)
    if (selectQuestion !== "default") {
      queryParams.push(`cropStageId=${selectQuestion}`);
    }

    // Join the query parameters with '&' to form the final query string
    const query = queryParams.length ? queryParams.join("&") : "";

    // Define headers, including x-tenantid
    const headers = {
      apiCountryCode: `${selectCountry}`, // Replace 'your_tenant_id' with the actual tenant ID
    };

    // Pass headers as an option to the service call
    CropStageCalendarService.getCropStageCalendarListAll(pNumber, size, query, { headers })
      .then((res) => {
        setLoading(false);
        let data = res?.data?.response.cropStageCalendars;
        let total = res?.data?.response?.totalItems;
        setCurrentPage(pNumber);
        setItemsPerPage(size)
        setTotalItems(total)
        data?.forEach((ele, index) => {
          ele.id = index;
          ele.StartFormatDate = dayjs.utc(ele?.startDate).format("DD/MM/YYYY");
          ele.EndFormatDate = dayjs.utc(ele?.endDate).format("DD/MM/YYYY")
        });

        setRows(data);
        // setTotalRowCount(total);
      })
      .catch((error) => {
        setLoading(false);
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
        setSeverity("error");
      });
  };

  const handleEditClick = (selectedRow) => {
    navigate("/editCropStageCalendar", { state: selectedRow });
  };

  const handleChange = (event) => {
    setTableVisible(false);
    setCropYear(event.target.value);
    setIsYearClicked(true);
  };

  const handleChangeYear = (event) => {
    setCropYear(event.target.value);
  };

  const handleButtonClick = async () => {
    try {
      setLoading(true);

      const response = await Service?.getCropStageList(
        `cropYear=${cropYear}&countryCode=BRA`
      );
      if (response?.data) {
        setLoading(false);
        setRows(
          response.data.map((row) => ({
            ...row,
            startDate: convertDateFormat(row.startDate),
            endDate: convertDateFormat(row.endDate),
          }))
        );
        setTableVisible(true);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
    setTableVisible(true);
  };

  function convertDateFormat(dateString) {
    if (!dateString) {
      return "";
    }

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date format: " + dateString);
    }

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    return `${day}/${month}/${year}`;
  }

  const handleChangeCountry = (event) => {
    setSelectCountry(event.target.value);
  };

  const handleChangeQuestion = (e) => {
    setSelectQuestion(e.target.value);
  };

    const handleExportExcel = async () => {
  setLoading(true);

  try {
    
let queryParams = [];

    if (cropYear !== "default") {
      queryParams.push(`cropYears=${cropYear}`);
    } else {
      cropYears?.forEach((year) => queryParams.push(`cropYears=${year}`));
    }

    if (selectQuestion !== "default") {
      queryParams.push(`cropStageId=${selectQuestion}`);
    }

    const query = queryParams.join("&");

    const headers = {
      apiCountryCode: `${selectCountry || firstCountry?.countryCode}`,
    };

    const res = await CropStageCalendarService.getCropStageCalendarListAll(0,10000,
      query,
      { headers }
    );

    const data = res?.data?.response?.cropStageCalendars || [];
 const exportData = data.map(item => ({
        'Country': item.countryName,
        'Crop Year': item.cropYear,
        'Season Code': `\u200B${item.seasonCode}`,
        'Season Name':item.seasonName,
        'Crop Stage':item.cropStageName,
        "Start Date": `\u200B${dayjs.utc(item?.startDate).format("DD/MM/YYYY")}`,
        "End Date": `\u200B${dayjs.utc(item?.endDate).format("DD/MM/YYYY")}`,
        'Status':(item.activeInd===true)?"Active":"Inactive"
        
      }));
    if (data.length === 0) {
      setSeverity("warning");
      setMessage("No data available to export");
      setOpenAlert(true);
      setLoading(false);
      return;
    }
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);
    
    XLSX.utils.book_append_sheet(wb, ws, "Crop Stage Calendar");

    XLSX.writeFile(wb, "Crop Stage Calendar.csv", { bookType: "csv" });
    setLoading(false);
  } catch (error) {
    setLoading(false);
    console.error("Export error:", error);
    setSeverity("error");
    setMessage("Failed to export Excel file");
    setOpenAlert(true);
  }
};

  return (
    <Layout title="Crop Stage Calendar">
      <div className="CropStageCalendarContainer">
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
            <Box sx={{ marginLeft: "1rem", marginTop: 2 }}>
              <Heading> Crop Stage Calendar</Heading>
            </Box>
          </Grid>
          {/* <Grid item xs={4}>
          <Box
            sx={{ display: "flex", alignItems: "center", marginLeft: "1rem" }}
          >
            <InputLabel sx={{ margin: 0 }} htmlFor="my-input">
              Last Modified By:
            </InputLabel>
            <Typography variant="body1">
              {" "}
              &nbsp;{state?.modifiedByUser}
            </Typography>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", marginLeft: "1rem" }}
          >
            <InputLabel sx={{ margin: 0 }} htmlFor="my-input">
              Last Modified Date:
            </InputLabel>
            <Typography variant="body1"> &nbsp;{formatDateDetails(state?.modifiedDateTimeUTC)}</Typography>
          </Box>
        </Grid> */}
        </Grid>
        <div>
          <>
            {user?.profiles?.some(profile => 
              profile.profileName === "Global ESG Admin" || 
              profile.profileName === "Global ESG Back office") ? (
              <RegistrationOptions>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={9}>
                    <FormControl sx={{ m: 1, minWidth: "200px" }}>
                      <TextField
                        select
                        value={selectCountry}
                        displayEmpty
                        onChange={handleChangeCountry}
                        inputProps={{ "aria-label": "Without label" }}
                        // label={year ? "" : "Crop Year"}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                maxHeight: 250, // Limit dropdown height
                              },
                            },
                          },
                        }}
                      >
                        {countries?.map((year) => (
                          <MenuItem
                            key={year.countryId}
                            value={year.countryCode}
                          >
                            {year.countryName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                    <FormControl sx={{ m: 1, minWidth: "200px" }}>
                      <TextField
                        select
                        value={cropYear}
                        onChange={handleChangeYear}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                      // label={year ? "" : "Crop Year"}
                      >
                        <MenuItem value={"default"}>Crop Year</MenuItem>
                        {cropYears.map((year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                    <FormControl sx={{ m: 1, minWidth: "200px" }}>
                      <TextField
                        select
                        value={selectQuestion}
                        onChange={handleChangeQuestion}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        // label={year ? "" : "Crop Year"}
                        SelectProps={{
                          MenuProps: {
                            PaperProps: {
                              sx: {
                                maxHeight: 250, // Limit dropdown height
                              },
                            },
                          },
                        }}
                      >
                        <MenuItem value={"default"}>Crop Stage</MenuItem>
                        {questions?.map((year) => (
                          <MenuItem
                            key={year.cropStageUid}
                            value={year.cropStageUid}
                          >
                            {year.cropStageName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>

                    <Button
                      sx={{
                        borderRadius: 4,
                        minWidth: 100,
                        minHeight: 50,
                        background: "#102A62",
                        marginTop: "13px",
                        marginLeft: "10px",
                      }}
                      variant="contained"
                      onClick={() => multiFilter(0, itemsPerPage)}
                      disabled={loading}
                    >
                      {loading && <CircularProgress size={20} />}
                      Get
                    </Button>
                  </Grid>
     <Grid item xs={12} md={3}justifyContent="flex-end"alignItems="center" container>
                      <Button
                                sx={{
                                  borderRadius: "10px",
                                  minWidth: 182,
                                  minHeight: 40,
                                  background: "#0F2B63", 
                                  marginTop: "8px",
                                  marginLeft: "20px",
                                  "&:hover": {
                                    backgroundColor: "#0F2B63",
                                  },
                                  padding:'8px 14px',
                                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", 
                                  fontFamily:"Montserrat",
                                  fontWeight:"600",
                                  fontSize:"16px",
                        
                                }}
                                variant="contained"
                                onClick={handleExportExcel}
                                disabled={loading||rows.length===0}
                              >
                                {loading && <CircularProgress size={20} />}
                                EXPORT TO EXCEL
                     </Button> 
                     </Grid>
                </Grid>
              </RegistrationOptions>
            ) : (
              <RegistrationOptions>
                <Grid container spacing={2}>
                 <Grid item xs={12} md={9} >
                    <FormControl sx={{ m: 1, minWidth: "200px" }}>
                      <TextField
                        select
                        value={cropYear}
                        onChange={handleChange}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                      // label={year ? "" : "Crop Year"}
                      >
                        <MenuItem value={"default"}>Crop Year</MenuItem>
                        {cropYears?.map((year) => (
                          <MenuItem key={year} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>

                    <Button
                      sx={{
                        borderRadius: 4,
                        minWidth: 100,
                        minHeight: 50,
                        background: "#102A62",
                        marginTop: "13px",
                        marginLeft: "10px",
                      }}
                      variant="contained"
                      onClick={() => fetchCropStageCalendar(0, itemsPerPage)}
                      disabled={loading}
                    >
                      {loading && <CircularProgress size={20} />}
                      Get
                    </Button>
                  </Grid>
                   <Grid item container xs={12} md={3} justifyContent="flex-end"alignItems="center">
                    <Button
                                sx={{
                                  borderRadius: "10px",
                                  minWidth: 182,
                                  minHeight: 40,
                                  background: "#0F2B63", 
                                  marginTop: "8px",
                                  marginLeft: "20px",
                                  float:"right",
                                  "&:hover": {
                                    backgroundColor: "#0F2B63",
                                  },
                                  padding:'8px 14px',
                                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", 
                                  fontFamily:"Montserrat",
                                  fontWeight:"600",
                                  fontSize:"16px",
                        
                                }}
                                variant="contained"
                                onClick={handleExportExcel}
                                disabled={loading ||rows.length===0}
                              >
                                {loading && <CircularProgress size={20} />}
                                EXPORT TO EXCEL
                              </Button> 
                    </Grid>
                </Grid>
              </RegistrationOptions>
            )}

            {loading ? (
              ""
            ) : (
              <>
                {rows && rows.length > 0 ? (
                  <DataContainer>
                    {user?.profiles?.some(profile => 
                      profile.profileName === "Global ESG Admin" || 
                      profile.profileName === "Global ESG Back office") ? (
                      <DataTable
                        rows={rows}
                        columns={columnsGlobal}
                        getRowId={(row) => row?.cropStageCalendarUid}
                        useClientPagination={false}
                      />
                    ) : (
                      <DataTable
                        getRowId={(row) => row?.cropStageCalendarUid}
                        rows={rows}
                        columns={columns}
                        useClientPagination={false}
                      />
                    )}
                  </DataContainer>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={NoData}
                      style={{ height: "100px" }}
                      alt="No Data"
                    />
                    <p>No Data Available</p>
                  </Box>
                )}
                {rows?.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      width: "96%",
                      bottom: "70px",
                    }}
                  >
                    {rows?.length > 0 && (
                      <CustomPagination
                        itemsPerPage={itemsPerPage}
                        setItemsPerPage = {(v)=>setItemsPerPage(v)}
                        totalItems={totalItems}
                        paginate={paginate}
                        currentPage={currentPage}
                        />
                    )}

                  </div>
                )}
              </>
            )}
          </>
        </div>
      </div>
    </Layout>
  );
};

export default CropStageCalendar;
